import { ObjectTypeContainer } from '../../containers/advancedFilters/ObjectTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const objectType: IFilter = {
  component: ObjectTypeContainer,
};
